resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';function ToolTip() {
  this.node = null;
  this.id = null;
  this.extends = [_ResponsiveLayout];
  this.declaredClass = null;

  //Properties
  this.targetElementId = null;
  this.targetParentSelector = null;
  this.targetScrollSelector = null;
  this.center = true;
  this.hover = false;
  this.closeIcon = true;
  this.minimumWidth = 150;

  //State
  this._isTouch = false;
  this._isPointingUp = false;
  this._tooltipPos = {};
  this._isVisible = false;

  this._classes = {
    container: 'tooltip',
    content: 'tooltip__container-content',
    arrow_up: 'tooltip__arrow-up',
    arrow_down: 'tooltip__arrow-down',
    close: 'tooltip__icon-cross icon-cross',
    closeable: 'tooltip--closeable',
    shown: 'tooltip--shown',
    positioning: 'tooltip--positioning',
    up: 'tooltip--up',
    down:'tooltip--down'
  };

  //Elements
  this._$nodeCopy = null;
  this._$body = null;
  this._$target = null;
  this._$close = $("<a class='" + this._classes.close + "'></a>");
  this._$content = $("<div class='" + this._classes.content + "'></div>");
  this._$arrowUp = $("<div class='" + this._classes.arrow_up + "'></div>");
  this._$arrowDown = $("<div class='" + this._classes.arrow_down + "'></div>");
  this._$arrow = null; //current arrow
  this._$portal = null;
  this._$nav = $('#main-nav');

  this._portalExists = false;
  this._navExists = this._$nav.length > 0;

  //Events
  this._documentCloseEvents = ["click","MSPointerDown","touchstart"];
  this._windowCloseEvents = ["orientationchange","resize"];
  this._eventNamespace = ".tooltip";

  this.init = function() {
    // Analytics definition
    this.analytics = new Analytics();
    this.analytics.extendEventObject({
      'component-tooltip-show': {
        event: "DLevent.toolTip",
        "toolTip": function () {
          return this.id;
        }
      }
    });

    if(!this.targetElementId) {
      console.error("targetElementId is a required property of ToolTip");
    } else {
      this._isTouch = $("html").hasClass("touch");
      this._eventNamespace += "-" + this.id;
      if(this.hover) this.closeIcon = false;

      this._initTemplate(); //init the element

      //Bind the Events
      if (this.hover && !this._isTouch){
        this._$target.hover(this.show.bind(this), this.hide.bind(this));
      } else {
        this._$target.on("click" + this._eventNamespace, this.show.bind(this));
      }

      $(document).on(this._documentCloseEvents.join(this._eventNamespace + " "), this._hideOnClick.bind(this));
      $(window).on(this._windowCloseEvents.join(this._eventNamespace + " "), this.hide.bind(this));

      if (this.targetScrollSelector) {
        //as the tooltip is positioned absolute relative to the body we want to update the position on scroll
        $(document).on("scroll" + this._eventNamespace, this.position.bind(this)); //TODO prevent body from scroling when dialog is open
        $(this.targetScrollSelector).on("scroll" + this._eventNamespace, this.position.bind(this)); //look at any elements that may scroll
      }
    }
  };

  this.initAllReady = function() {};

  this.destroy = function() {
    this._$nodeCopy.remove();
    $(document).off(this._eventNamespace);
    $(window).off(this._eventNamespace);
    if (this.targetScrollSelector) $(this.targetScrollSelector).off(this._eventNamespace);
  };

  this.hide = function() {
    if (!this._isVisible) return; //only hide if visible
    this._$nodeCopy.removeClass(this._classes.shown);
    this._isVisible = false;
  };

  this.show = function(event) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    // hide any visible tooltips first
    if (!this._allTooltips) this._allTooltips = document.querySelectorAll('[data-mogo-ui="ToolTip"]');
    for (var i = 0; i < this._allTooltips.length; i++) {
      if (this._allTooltips[i].mogo()._isVisible) this._allTooltips[i].mogo().hide();
    }

    // determine portal context
    var target = $(event.originalEvent.target);
    this._$portal = target.closest('[class*="portal__"]'); //$('.portal__content-inner');
    this._portalExists = this._$portal.length > 0;

    this._isVisible = true;
    this._$nodeCopy.addClass(this._classes.positioning);
    this.position();
    this._$nodeCopy.addClass(this._classes.shown).removeClass(this._classes.positioning);

    this.analytics.pushEvent('component-tooltip-show', null, this);
  };

  this.position = function() {
    if (!this._isVisible) return; //only position if visible
    //update position
    this._$nodeCopy.css("margin-left", ""); //Reset margin-left

    this._initialPosition(false);
    this._adjustPosition(this._portalExists, this._navExists);
  };

  //Private Methods
  this._hideOnClick = function(evt) {
    if (!this._isVisible) return; //only hide if visible
    var target = $(evt.originalEvent.target);
    var isChildOfTarget = target.parents("#" + this.targetElementId).length > 0;
    var isChildOfTargetParent = this.targetParentSelector && this._$target.parents(this.targetParentSelector).find(evt.originalEvent.target).length > 0;
    var isTooltipContent = evt.target.className == this._classes.content;
    var isTargetOfLink = $(evt.originalEvent.target).attr('href');
    if( !(isChildOfTarget || isChildOfTargetParent || isTooltipContent) && !isTargetOfLink ) this.hide();
  };


  this._initialPosition = function(isPointingUp){
    this._toggleArrow(isPointingUp);
    this._tooltipPos.top = this._getTopPostion();
    this._tooltipPos.left = this._getLeftPosition();
    this._$nodeCopy.css(this._tooltipPos);
    this._positionArrowOnTarget();
    //TOOD: heightChange if pointing down?
  };

  this._adjustPosition = function(portalExists, navExists){
    //Make sure the tooltip is rendered inside the body
    //Get the exact location of tooltip after the adjustments
    var contentWidth = this._$body.outerWidth();

    var navBounds = {
      height: 0,
      width: 0
    };
    // account for the nav dimensions to prevent overlap with tooltip
    if (navExists) {
      if ($(window).width() > 640) {
        navBounds.width = this._$nav.width();
      } else {
        navBounds.height = this._$nav.height();
      }
    }

    // if we're in the portal, limit the tooltip to the main content area width
    if (portalExists) {
      contentWidth = this._$portal.outerWidth();
      this._$nodeCopy.css("max-width", contentWidth - 4);
      // and reposition to account for change in height
      this._initialPosition(false);
    }

    // is it too narrow?
    if (this._$nodeCopy.width() < this.minimumWidth) {
      // force a set width
      this._$nodeCopy.css("width", this.minimumWidth);
      // and reposition to account for change in height
      this._initialPosition(false);
    }

    var tooltip_pos_rect = this._$nodeCopy[0].getBoundingClientRect();

    // Is it overlapping icon?
    if (tooltip_pos_rect.bottom > this._$target.offset().top) {
      this._$nodeCopy.css('top', tooltip_pos_rect.top - (tooltip_pos_rect.bottom - this._$target.offset().top));
    }

    //Is it cutting out of view from top or overlapping icon?
    //If so, position tooltip on bottom of the target
    if (tooltip_pos_rect.top < navBounds.height)
      this._initialPosition(true);

    //Is it cutting out of view from left?
    if (tooltip_pos_rect.left < navBounds.width) {
      //Move more towards right
      var cutOffLeftOffset = 2 - tooltip_pos_rect.left + navBounds.width;
      this._$nodeCopy.css("margin-left", cutOffLeftOffset);
      this._positionArrowOnTarget();
    }

    //Is it cutting out of view from right?
    if (tooltip_pos_rect.right > contentWidth + this._$portal.position().left) {
      //Move more towards left
      var cutOffRightOffset = (tooltip_pos_rect.right - contentWidth - this._$portal.position().left - navBounds.width) + 2;
      this._$nodeCopy.css("margin-left", -cutOffRightOffset);
      this._positionArrowOnTarget();
    }

    //TOOD: heightChange if pointing down?
  };

  /*
  this._heightChange = function() {
    //Handle height changes on display
    //Not sure if this is acutally required
    this._tooltip_pos.top = this._$target.offset().top - this._$nodeCopy.innerHeight() - 2;
    if(this._tooltip_pos.top < this._$nodeCopy.position().top){
      this._$nodeCopy.css("top", this._tooltip_pos.top);
    }
  };
  */

  this._toggleArrow = function(isPointingUp) {
    this._isPointingUp = isPointingUp;
    this._$arrow = this._isPointingUp ? this._$arrowUp : this._$arrowDown;
    this._$nodeCopy.toggleClass(this._classes.up, this._isPointingUp);
    this._$nodeCopy.toggleClass(this._classes.down, !this._isPointingUp);
  };

  this._getTopPostion = function() {
    var top = this._$target.offset().top;
    if (this._isPointingUp) {
      top += this._$target.innerHeight() + 2;
    } else {
      top -= this._$nodeCopy.innerHeight() + 2;
    }
    return top;
  };

  this._getLeftPosition = function(){
    var bounding_box = this._$target[0].getBoundingClientRect();
    if(this.center){
      var centerPoint = bounding_box.left + bounding_box.width/2;
      return centerPoint - this._$nodeCopy.width()/2;
    } else {
      return bounding_box.left - bounding_box.width/2;
    }
  };

  this._positionArrowOnTarget = function(){
    var target_pos = this._$target.offset();
    var tooltip_pos = this._$nodeCopy.offset();
    var arrow_left = target_pos.left - tooltip_pos.left - 10 + (this._$target.innerWidth()/2);
    this._$arrow.css("margin-left", arrow_left);
  };


  this._initTemplate = function(){
    this._$body = $("body");
    this._$target = $("#" + this.targetElementId);

    //create a copy of the node
    this._$nodeCopy = $(this.node).clone();
    this._$nodeCopy.removeAttr("id").addClass(this._classes.container);

    //move the contents of the copy to the content element
    this._$nodeCopy.contents().appendTo(this._$content);

    this._$nodeCopy.append(this._$arrowUp);
    this._$nodeCopy.append(this._$content);
    this._$nodeCopy.append(this._$arrowDown);

    this._$body.append(this._$nodeCopy); //append the node to the page

    //add the close icon if specified
    if (this.closeIcon) {
      this._$nodeCopy.addClass(this._classes.closeable).append(this._$close);
      this._$close.on("click" + this._eventNamespace, this.hide.bind(this));
    }
  };
}
